import { MODULOS, OPERADORES_DE_VALIDACAO, TIPO_CONDICAO, FUNCIONALIDADES } from 'src/core/modulos/index.ts'
import simpleChildrenWrapper from './wrapper'
import i18n from '@/typescript/servicos/i18n/i18n.servico'

const MinhasSolicitacoes = () => import('../components/Approvals/MinhasSolicitacoes.vue')
const AcessoNegado = () => import('src/components/AcessoNegado/AcessoNegado.vue')
const AcompanhamentoTempoReal = () => import('src/components/AcompanhamentoTempoReal/AcompanhamentoTempoReal.vue')
const FarolDoDP2 = () => import('src/components/FarolDoDP2/FarolDoDP2.vue')
const ApprovalsRulesDetails = () => import('src/components/ApprovalsRules/details/ApprovalsRulesDetails')
const ApprovalsRulesList = () => import('src/components/ApprovalsRules/list/ApprovalsRulesList.vue')
const Auditor = () => import('src/components/Auditor/Auditor.vue')
const Faturas = () => import('src/typescript/modulos/tiosam/faturas/apresentacao/Faturas.vue')
const Cognito = () => import('src/components/Cognito/MainScreens/Cognito.vue')
const CompanyDetails = () => import('src/components/Company/details/CompanyDetails.vue')
const CompanyList = () => import('src/components/Company/list/CompanyList.vue')
const ConfirmSignUp = () => import('src/components/Cognito/MainScreens/ConfirmSignUp.vue')
const CriacaoEdicaoDaRegraDeCalculo = () => import('src/components/CustomizacoesDeCalculo/Telas/CriacaoEdicaoRegraDeCalculo.vue')
const CriacaoEdicaoDePerfil = () => import('src/components/Coletores/Componentes/Perfil/CriarOuEditarPerfil.vue')
const CriacaoEdicaoGrupoDeRubricas = () => import('src/components/CustomizacoesDeCalculo/Telas/CriacaoEdicaoGrupoDeRubricas.vue')
const CriarEditarRegraDeNotificacao = () => import('src/typescript/modulos/acompanhamento/RegraDeNotificacao/apresentacao/criarEditar/CriarEditarRegraDeNotificacao.vue')
const CriarOuEditarPermissao = () => import('src/components/Permissions/criacaoOuEdicao/CriarOuEditarPermissao.vue')
const DetalhesDadosDaEmpresa = () => import('src/components/CompMan/DetalhesDadosDaEmpresa.vue')
const DetalhesDeRegraDeBancoDeHoras = () => import('src/components/HourBankRules/details/DetalhesDeRegraDeBancoDeHoras.vue')
const DevicesList = () => import('src/components/Devices/DevicesList.vue')
const ControleDeEstacoes = () => import('src/components/ControleDeEstacoes/ControleDeEstacoes.vue')
const EmployeeDetails = () => import('src/components/Employee/details/EmployeeDetails.vue')
const EmployeeList = () => import('src/components/Employee/list/EmployeeList.vue')
const EmployerDetails = () => import('src/components/Employer/details/EmployerDetails.vue')
const EmployerList = () => import('src/components/Employer/list/EmployerList.vue')
const ExtraTimeDash = () => import('src/components/DashBoards/ExtraTimeDash')
const FaceBiometric = () => import('src/components/FaceBiometric/FaceBiometricScreen.vue')
const PaginaAcessoPeloComputador = () => import('src/typescript/modulos/estrutura-de-pontos-da-empresa/biometria/apresentacao/paginas/PaginaAcessoPeloComputador.vue')
const PaginaAutenticarBiometria = () => import('src/typescript/modulos/estrutura-de-pontos-da-empresa/biometria/apresentacao/paginas/PaginaAutenticarBiometria.vue')
const PaginaConfirmarIdentidade = () => import('src/typescript/modulos/estrutura-de-pontos-da-empresa/biometria/apresentacao/paginas/PaginaConfirmarIdentidade.vue')
const PaginaCameraBiometria = () => import('src/typescript/modulos/estrutura-de-pontos-da-empresa/biometria/apresentacao/paginas/PaginaCameraBiometria.vue')
const FeriasEAfastamentos = () => import('src/components/FeriasEAfastamentos/FeriasEAfastamentos.vue')
const FileManagementApproval = () => import('src/components/FileManagement/approval/FileManagementApproval.vue')
const FileManagementList = () => import('src/components/FileManagement/list/FileManagementList.vue')
const GerenciamentoDeFerias = () => import('src/typescript/modulos/calendario-de-trabalho/GerenciamentoDeFerias/apresentacao/GerenciamentoDeFerias.vue')
const CriarEditarRegraDeFerias = () => import('src/typescript/modulos/calendario-de-trabalho/RegrasDeFerias/apresentacao/CriarEditarRegraDeFerias.vue')
const RegrasDeFerias = () => import('src/typescript/modulos/calendario-de-trabalho/RegrasDeFerias/apresentacao/RegrasDeFerias.vue')
const GestaoDeSolicitacoes = () => import('src/components/Approvals/GestaoDeSolicitacoes')
const GroupsList = () => import('src/components/Groups/GroupsList.vue')
const HolidayList = () => import('src/components/Holiday/list/HolidayList.vue')
const Home = () => import('@/components/Home/Home.vue')
const JourneyList = () => import('src/components/Journey/JourneyList.vue')
const LancarSolicitacoes = () => import ('@/components/Approvals/LancarSolicitacoes')
const ListagemDaCustomizacaoDeCalculo = () => import('src/components/CustomizacoesDeCalculo/Telas/ListagemDaCustomizacaoDeCalculo.vue')
const ListagemDasRegrasDeBancoDeHoras = () => import('src/components/HourBankRules/list/ListagemDasRegrasDeBancoDeHoras.vue')
const ListagemDeColetores = () => import('src/components/Coletores/Telas/ListagemDeColetores.vue')
const ListagemDeLogDeOperacoes = () => import('src/components/LogDeOperacoes/ListagemDeLogDeOperacoes.vue')
const ListagemDePermissoes = () => import('src/components/Permissions/list/ListagemDePermissoes.vue')
const ListagemDeVerbas = () => import('src/components/ParametrizadorE02/Telas/ListagemDeVerbas.vue')
const LockerManagement = () => import('src/components/Locker/LockerManagement.vue')
const LockerRulesDetails = () => import('src/components/LockerRules/details/LockerRulesDetails.vue')
const LockerRulesList = () => import('src/components/LockerRules/list/LockerRulesList.vue')
const MassChanges = () => import('src/components/MassChanges/MassChanges.vue')
const MultipleChanges = () => import('src/components/Employee/multipleChanges/MultipleChanges.vue')
const PainelDePontos = () => import('src/components/PainelDePontos/PainelDePontos')
const PainelDeSolicitacoesDeHorasExtras = () => import('src/typescript/modulos/acompanhamento/PainelSolicitacoesDeHorasExtras/apresentacao/PainelSolicitacoesDeHorasExtras.vue')
const ReasonList = () => import('src/components/Reason/list/ReasonList.vue')
const ReasonDetails = () => import('src/components/Reason/details/ReasonDetails.vue')
const RegrasDeNotificacao = () => import('src/typescript/modulos/acompanhamento/RegraDeNotificacao/apresentacao/RegraDeNotificacao.vue')
const RegrasDeNotificacaoListagem = () => import('src/typescript/modulos/acompanhamento/RegraDeNotificacao/apresentacao/listagem/RegraDeNotificacaoListagem.vue')
const Reports = () => import('src/components/Reports/Reports.vue')
const RoutineDetails = () => import('src/components/Routine/details/RoutineDetails.vue')
const RoutineList = () => import('src/components/Routine/list/RoutineList.vue')
const SetupDeIntegracoes = () => import('src/components/Sankhya/SetupDeIntegracoes.vue')
const IntegracaoVerbasEFaltas = () => import('src/components/Sankhya/IntegracaoVerbasEFaltas.vue')
const Timesheet = () => import('src/components/Sheets/Timesheet/Timesheet.vue')
const UserList = () => import('src/components/User/list/UserList.vue')
const VerifyTimesheet = () => import('src/components/Sheets/VerifyTimesheet/VerifyTimesheet')
const WhbManagement = () => import('src/components/Whb/WhbManagement.vue')
const WorkSchedule = () => import('src/components/WorkSchedule/WorkSchedule.vue')
const Exportador = () => import('src/typescript/modulos/calculos-do-sistema/e02/apresentacao/layoutE02/Exportador.vue')
const ListaLayoutsE02 = () => import('src/typescript/modulos/calculos-do-sistema/e02/apresentacao/tabela/TabelaLayouts.vue')
const CalendarioDeFerias = () => import('src/typescript/modulos/calendario-de-trabalho/GerenciamentoDeFerias/apresentacao/CalendarioDeFerias/CalendarioDeFerias.vue')
const CalendarioAloque = () => import('src/typescript/modulos/calendario-de-trabalho/CalendarioAloque/apresentacao/CalendarioAloque.vue')
const CentralAtendimento = () => import('src/components/CentralAtendimento/CentralAtendimento.vue')
const ChatPoliticas = () => import('src/components/ChatPoliticas/ChatPoliticas.vue')
const ConexoesMcp = () => import('src/typescript/modulos/governanca/ConexoesMcp/apresentacao/ConexoesMcp.vue')

const UUIDPathUrl = ':id([a-fA-F0-9]{8}-[a-fA-F0-9]{4}-[a-fA-F0-9]{4}-[a-fA-F0-9]{4}-[a-fA-F0-9]{12})'
const UUIDOrObjectIdPathUrl = ':id([a-fA-F0-9]{24}|[a-fA-F0-9]{8}-[a-fA-F0-9]{4}-[a-fA-F0-9]{4}-[a-fA-F0-9]{4}-[a-fA-F0-9]{12})';


const ROTAS_BASE = [
  {
    path: '/cognito/confirmSignUp',
    name: 'cognito.confirmSignUp',
    component: ConfirmSignUp,
    props: function (route) {
      return {
        email: route.query.email,
        tempPassword: route.query.code
      }
    },
    meta: {
      title: 'confirmar entrada',
      dontNeedAuth: true,
      requisitosDeAcesso: {
        operador: OPERADORES_DE_VALIDACAO.OU,
        condicoes: [{ tipo: TIPO_CONDICAO.MODULO, modulo: [MODULOS.BASE] }]
      }
    }
  },
  {
    path: '/central-atendimento',
    name: 'centralAtendimento',
    component: CentralAtendimento,
    meta: {
      title: 'Central de Atendimento',
      requisitosDeAcesso: {
        operador: OPERADORES_DE_VALIDACAO.OU,
        condicoes: [{ tipo: TIPO_CONDICAO.MODULO, modulo: [MODULOS.BASE] }]
      }
    }
  },
  {
    path: '/cognito/applyForgotPassword',
    name: 'cognito.applyForgotPassword',
    component: Cognito,
    props: function (route) {
      return {
        type: 'applyForgotPassword',
        forgotPasswordData: route.query
      }
    },
    meta: {
      dontNeedAuth: true,
      requisitosDeAcesso: {
        operador: OPERADORES_DE_VALIDACAO.OU,
        condicoes: [{ tipo: TIPO_CONDICAO.MODULO, modulo: [MODULOS.BASE] }]
      }
    }
  },

  {
    path: '/cognito/:type',
    name: 'cognito',
    component: Cognito,
    props: true,
    meta: {
      dontNeedAuth: true,
      title: 'login',
      requisitosDeAcesso: {
        operador: OPERADORES_DE_VALIDACAO.OU,
        condicoes: [{ tipo: TIPO_CONDICAO.MODULO, modulo: [MODULOS.BASE] }]
      }
    }
  },

  {
    path: '/acesso-negado',
    name: 'AcessoNegado',
    component: AcessoNegado,
    meta: {
      title: 'Acesso Negado',
      dontNeedAuth: true,
      requisitosDeAcesso: {
        operador: OPERADORES_DE_VALIDACAO.OU,
        condicoes: [{ tipo: TIPO_CONDICAO.MODULO, modulo: [MODULOS.BASE] }]
      }
    }
  },

  {
    path: '/',
    name: 'home',
    component: Home,
    meta: {
      title: 'Pontotel | Início',
      requisitosDeAcesso: {
        operador: OPERADORES_DE_VALIDACAO.OU,
        condicoes: [{ tipo: TIPO_CONDICAO.MODULO, modulo: [MODULOS.BASE] }]
      }
    }
  },
  {
    path: '/afast/:id([0-9abcdef]{15,})',
    name: 'afast',
    component: FeriasEAfastamentos,
    props: true,
    meta: {
      title: 'Afastamentos e Férias',
      requisitosDeAcesso: {
        operador: OPERADORES_DE_VALIDACAO.OU,
        condicoes: [{ tipo: TIPO_CONDICAO.MODULO, modulo: [MODULOS.BASE] }]
      },
    }
  },

  {
    path: '/employee',
    name: 'employee',
    component: simpleChildrenWrapper,
    children: [
      {
        path: 'list',
        name: 'employee.list',
        component: EmployeeList,
        meta: {
          title: 'empregados',
          requisitosDeAcesso: {
            operador: OPERADORES_DE_VALIDACAO.OU,
            condicoes: [{ tipo: TIPO_CONDICAO.MODULO, modulo: [MODULOS.BASE] }]
          }
        }
      },
      {
        path: 'list/:filter/:fieldId([0-9abcdef]{15,})/:fieldName',
        name: 'employee.list.filter',
        component: EmployeeList,
        props: true,
        meta: {
          title: i18n.t('router.routes.employee.funcionarios'),
          requisitosDeAcesso: {
            operador: OPERADORES_DE_VALIDACAO.OU,
            condicoes: [{ tipo: TIPO_CONDICAO.MODULO, modulo: [MODULOS.BASE] }]
          }
        }
      },
      {
        path: 'new',
        name: 'employee.new',
        component: EmployeeDetails,
        meta: {
          title: 'Novo empregado',
          requisitosDeAcesso: {
            operador: OPERADORES_DE_VALIDACAO.OU,
            condicoes: [{ tipo: TIPO_CONDICAO.MODULO, modulo: [MODULOS.BASE] }]
          }
        }
      },
      {
        path: 'all',
        name: 'employee.multipleChanges',
        component: MultipleChanges,
        meta: {
          title: i18n.t('router.routes.employee.alteracoesMultiplas'),
          requisitosDeAcesso: {
            operador: OPERADORES_DE_VALIDACAO.OU,
            condicoes: [{ tipo: TIPO_CONDICAO.MODULO, modulo: [MODULOS.BASE] }]
          }
        }
      },
      {
        path: ':id([0-9abcdef]{15,})',
        name: 'employee.edit',
        component: EmployeeDetails,
        props: true,
        meta: {
          parametroDeIdentidade: 'id',
          title: 'Cadastro de empregado',
          requisitosDeAcesso: {
            operador: OPERADORES_DE_VALIDACAO.OU,
            condicoes: [{ tipo: TIPO_CONDICAO.MODULO, modulo: [MODULOS.BASE] }]
          }
        }
      }
    ],
    meta: {
      requisitosDeAcesso: {
        operador: OPERADORES_DE_VALIDACAO.OU,
        condicoes: [{ tipo: TIPO_CONDICAO.MODULO, modulo: [MODULOS.BASE] }]
      }
    }
  },

  {
    path: '/company',
    name: 'company',
    component: simpleChildrenWrapper,
    children: [
      {
        path: 'list',
        name: 'company.list',
        component: CompanyList,
        meta: {
          title: i18n.t('router.routes.company.locais'),
          requisitosDeAcesso: {
            operador: OPERADORES_DE_VALIDACAO.OU,
            condicoes: [{ tipo: TIPO_CONDICAO.MODULO, modulo: [MODULOS.BASE] }]
          }
        }
      },
      {
        path: 'new',
        name: 'company.new',
        component: CompanyDetails,
        meta: {
          title: i18n.t('router.routes.company.novoLocal'),
          requisitosDeAcesso: {
            operador: OPERADORES_DE_VALIDACAO.OU,
            condicoes: [{ tipo: TIPO_CONDICAO.MODULO, modulo: [MODULOS.BASE] }]
          }
        }
      },
      {
        path: ':id([0-9abcdef]{15,})',
        name: 'company.edit',
        component: CompanyDetails,
        props: true,
        meta: {
          title: i18n.t('router.routes.company.editarLocal'),
          parametroDeIdentidade: 'id',
          requisitosDeAcesso: {
            operador: OPERADORES_DE_VALIDACAO.OU,
            condicoes: [{ tipo: TIPO_CONDICAO.MODULO, modulo: [MODULOS.BASE] }]
          }
        }
      }
    ],
    meta: {
      requisitosDeAcesso: {
        operador: OPERADORES_DE_VALIDACAO.OU,
        condicoes: [{ tipo: TIPO_CONDICAO.MODULO, modulo: [MODULOS.BASE] }]
      }
    }
  },

  {
    path: '/employer',
    name: 'employer',
    component: simpleChildrenWrapper,
    children: [
      {
        path: 'list',
        name: 'employer.list',
        component: EmployerList,
        meta: {
          title: i18n.t('router.routes.employer.empregadores'),
          requisitosDeAcesso: {
            operador: OPERADORES_DE_VALIDACAO.OU,
            condicoes: [{ tipo: TIPO_CONDICAO.MODULO, modulo: [MODULOS.BASE] }]
          }
        }
      },
      {
        path: 'new',
        name: 'employer.new',
        component: EmployerDetails,
        meta: {
          title: i18n.t('router.routes.employer.novoEmpregador'),
          requisitosDeAcesso: {
            operador: OPERADORES_DE_VALIDACAO.OU,
            condicoes: [{ tipo: TIPO_CONDICAO.MODULO, modulo: [MODULOS.BASE] }]
          }
        }
      },
      {
        path: ':id([0-9abcdef]{15,})',
        name: 'employer.edit',
        component: EmployerDetails,
        props: true,
        meta: {
          title: i18n.t('router.routes.employer.editarEmpregador'),
          parametroDeIdentidade: 'id',
          requisitosDeAcesso: {
            operador: OPERADORES_DE_VALIDACAO.OU,
            condicoes: [{ tipo: TIPO_CONDICAO.MODULO, modulo: [MODULOS.BASE] }]
          }
        }
      }
    ],
    meta: {
      requisitosDeAcesso: {
        operador: OPERADORES_DE_VALIDACAO.OU,
        condicoes: [{ tipo: TIPO_CONDICAO.MODULO, modulo: [MODULOS.BASE] }]
      }
    }
  },

  {
    path: '/user-group',
    name: 'user-group',
    component: GroupsList,
    meta: {
      title: i18n.t('router.routes.grupos'),
      requisitosDeAcesso: {
        operador: OPERADORES_DE_VALIDACAO.OU,
        condicoes: [{ tipo: TIPO_CONDICAO.MODULO, modulo: [MODULOS.BASE] }]
      }
    }
  },

  {
    path: '/workjourney/create',
    name: 'workjourney.create',
    component: JourneyList,
    props: { criacao: true },
    meta: {
      title: i18n.t('router.routes.jornadas'),
      requisitosDeAcesso: {
        operador: OPERADORES_DE_VALIDACAO.OU,
        condicoes: [{ tipo: TIPO_CONDICAO.MODULO, modulo: [MODULOS.BASE] }]
      }
    }
  },

  {
    path: '/workjourney',
    name: 'workjourney',
    component: JourneyList,
    props: true,
    meta: {
      title: i18n.t('router.routes.jornadas'),
      requisitosDeAcesso: {
        operador: OPERADORES_DE_VALIDACAO.OU,
        condicoes: [{ tipo: TIPO_CONDICAO.MODULO, modulo: [MODULOS.BASE] }]
      }
    }
  },

  {
    path: '/routine',
    name: 'routine',
    component: simpleChildrenWrapper,
    children: [
      {
        path: 'list',
        name: 'routine.list',
        component: RoutineList,
        meta: {
          title: i18n.t('router.routes.routine.escalas'),
          requisitosDeAcesso: {
            operador: OPERADORES_DE_VALIDACAO.OU,
            condicoes: [{ tipo: TIPO_CONDICAO.MODULO, modulo: [MODULOS.BASE] }]
          }
        }
      },
      {
        path: 'new',
        name: 'routine.new',
        component: RoutineDetails,
        meta: {
          title: i18n.t('router.routes.routine.novaEscala'),
          requisitosDeAcesso: {
            operador: OPERADORES_DE_VALIDACAO.OU,
            condicoes: [{ tipo: TIPO_CONDICAO.MODULO, modulo: [MODULOS.BASE] }]
          }
        }
      },
      {
        path: ':id([0-9abcdef]{15,})',
        name: 'routine.edit',
        component: RoutineDetails,
        props: true,
        meta: {
          title: i18n.t('router.routes.routine.editarEscala'),
          parametroDeIdentidade: 'id',
          requisitosDeAcesso: {
            operador: OPERADORES_DE_VALIDACAO.OU,
            condicoes: [{ tipo: TIPO_CONDICAO.MODULO, modulo: [MODULOS.BASE] }]
          }
        }
      }
    ],
    meta: {
      requisitosDeAcesso: {
        operador: OPERADORES_DE_VALIDACAO.OU,
        condicoes: [{ tipo: TIPO_CONDICAO.MODULO, modulo: [MODULOS.BASE] }]
      }
    }
  },

  {
    path: '/holidays',
    name: 'holidays',
    component: HolidayList,
    meta: {
      title: i18n.t('router.routes.feriados'),
      requisitosDeAcesso: {
        operador: OPERADORES_DE_VALIDACAO.OU,
        condicoes: [{ tipo: TIPO_CONDICAO.MODULO, modulo: [MODULOS.BASE] }]
      }
    }
  },
  {
    path: '/holidays/create',
    name: 'holidays.create',
    component: HolidayList,
    props: { criacao: true },
    meta: {
      title: i18n.t('router.routes.feriados'),
      requisitosDeAcesso: {
        operador: OPERADORES_DE_VALIDACAO.OU,
        condicoes: [{ tipo: TIPO_CONDICAO.MODULO, modulo: [MODULOS.BASE] }]
      }
    }
  },

  {
    path: '/holidays/:feriadoId([0-9a-f]{24})',
    name: 'holidays.edit',
    component: HolidayList,
    props: true,
    meta: {
      title: i18n.t('router.routes.feriados'),
      requisitosDeAcesso: {
        operador: OPERADORES_DE_VALIDACAO.OU,
        condicoes: [{ tipo: TIPO_CONDICAO.MODULO, modulo: [MODULOS.BASE] }]
      }
    }
  },

  {
    path: '/fechamentos',
    name: 'reports',
    component: Reports,
    meta: {
      title: i18n.t('router.routes.relatorios'),
      requisitosDeAcesso: {
        operador: OPERADORES_DE_VALIDACAO.OU,
        condicoes: [{ tipo: TIPO_CONDICAO.MODULO, modulo: [MODULOS.BASE] }]
      }
    }
  },

  {
    path: '/user',
    name: 'user',
    component: simpleChildrenWrapper,
    children: [
      {
        path: 'create',
        name: 'user.create',
        component: UserList,
        props: { criacao: true },
        meta: {
          title: i18n.t('router.routes.usuarios'),
          requisitosDeAcesso: {
            operador: OPERADORES_DE_VALIDACAO.OU,
            condicoes: [{ tipo: TIPO_CONDICAO.MODULO, modulo: [MODULOS.BASE] }]
          }
        }
      },
      {
        path: ':id([0-9abcdef]{15,})?',
        name: 'user.edit', component: UserList,
        props: true,
        meta: {
          title: i18n.t('router.routes.usuarios'),
          requisitosDeAcesso: {
            operador: OPERADORES_DE_VALIDACAO.OU,
            condicoes: [{ tipo: TIPO_CONDICAO.MODULO, modulo: [MODULOS.BASE] }]
          }
        }
      },
      {
        path: 'new/:employeeId([0-9abcdef]{15,})',
        name: 'user.new', component: UserList,
        props: true,
        meta: {
          title: i18n.t('router.routes.usuarios'),
          requisitosDeAcesso: {
            operador: OPERADORES_DE_VALIDACAO.OU,
            condicoes: [{ tipo: TIPO_CONDICAO.MODULO, modulo: [MODULOS.BASE] }]
          }
        }
      }
    ],
    meta: {
      requisitosDeAcesso: {
        operador: OPERADORES_DE_VALIDACAO.OU,
        condicoes: [{ tipo: TIPO_CONDICAO.MODULO, modulo: [MODULOS.BASE] }]
      }
    }
  },

  {
    path: '/permissions',
    name: 'permissions',
    component: simpleChildrenWrapper,
    children: [
      {
        path: 'list',
        name: 'permissions.list',
        component: ListagemDePermissoes,
        meta: {
          title: i18n.t('router.routes.permissions.permissoes'),
          requisitosDeAcesso: {
            operador: OPERADORES_DE_VALIDACAO.OU,
            condicoes: [{ tipo: TIPO_CONDICAO.MODULO, modulo: [MODULOS.BASE] }]
          }
        }
      },
      {
        path: 'new',
        name: 'permissions.new',
        component: CriarOuEditarPermissao,
        meta: {
          title: i18n.t('router.routes.permissions.novaPermissao'),
          requisitosDeAcesso: {
            operador: OPERADORES_DE_VALIDACAO.OU,
            condicoes: [{ tipo: TIPO_CONDICAO.MODULO, modulo: [MODULOS.BASE] }]
          }
        }
      },
      {
        path: ':id([0-9abcdef]{15,})',
        name: 'permissions.edit',
        component: CriarOuEditarPermissao,
        props: true,
        meta: {
          title: i18n.t('router.routes.permissions.editarPermissao'),
          requisitosDeAcesso: {
            operador: OPERADORES_DE_VALIDACAO.OU,
            condicoes: [{ tipo: TIPO_CONDICAO.MODULO, modulo: [MODULOS.BASE] }]
          }
        }
      }
    ],
    meta: {
      requisitosDeAcesso: {
        operador: OPERADORES_DE_VALIDACAO.OU,
        condicoes: [{ tipo: TIPO_CONDICAO.MODULO, modulo: [MODULOS.BASE] }]
      }
    }
  },

  {
    // Fora do menu de propósito: a tela é do atendimento e abre pela URL. Quem
    // não é suporte com chave de API volta para a home (`requerAcessoConexoesMcp`,
    // em router/index.js) e, se insistir, o backend recusa com 403.
    path: '/conexoes-mcp',
    name: 'ConexoesMcp',
    component: ConexoesMcp,
    meta: {
      title: i18n.t('router.routes.conexoesMcp'),
      requerAcessoConexoesMcp: true,
      requisitosDeAcesso: {
        operador: OPERADORES_DE_VALIDACAO.OU,
        condicoes: [{ tipo: TIPO_CONDICAO.MODULO, modulo: [MODULOS.BASE] }]
      }
    }
  },

  {
    path: '/dados',
    name: 'dados',
    component: DetalhesDadosDaEmpresa,
    meta: {
      title: i18n.t('router.routes.dados'),
      requisitosDeAcesso: {
        operador: OPERADORES_DE_VALIDACAO.OU,
        condicoes: [{ tipo: TIPO_CONDICAO.MODULO, modulo: [MODULOS.BASE] }]
      },
    }
  },

  {
    path: '/log',
    name: 'LogDeOperacoes',
    component: ListagemDeLogDeOperacoes,
    meta: {
      title: i18n.t('router.routes.logOperacoes'),
      requisitosDeAcesso: {
        operador: OPERADORES_DE_VALIDACAO.OU,
        condicoes: [{ tipo: TIPO_CONDICAO.MODULO, modulo: [MODULOS.BASE] }]
      }
    }
  },

  {
    path: '/auditor',
    name: 'Auditor',
    component: Auditor,
    meta: {
      title: 'Auditorias de Integrações',
      requisitosDeAcesso: {
        operador: OPERADORES_DE_VALIDACAO.OU,
        condicoes: [{ tipo: TIPO_CONDICAO.MODULO, modulo: [MODULOS.BASE] }]
      }
    }
  },

  {
    path: '/setup',
    name: 'SetupDeIntegracoes',
    component: SetupDeIntegracoes,
    meta: {
      title: 'Configuração de Integrações',
      requisitosDeAcesso: {
        operador: OPERADORES_DE_VALIDACAO.OU,
        condicoes: [{ tipo: TIPO_CONDICAO.MODULO, modulo: [MODULOS.BASE] }]
      },
    }
  },

  {
    path: '/integracao/verbas-e-faltas',
    name: 'IntegracaoVerbasEFaltas',
    component: IntegracaoVerbasEFaltas,
    meta: {
      title: 'Integração de verbas e faltas',
      requisitosDeAcesso: {
        operador: OPERADORES_DE_VALIDACAO.OU,
        condicoes: [{ tipo: TIPO_CONDICAO.MODULO, modulo: [MODULOS.BASE] }]
      },
    }
  },

  {
    path: '/farol-do-dp',
    name: 'FarolDoDP',
    component: FarolDoDP2,
    meta: {
      title: 'Farol do DP',
      requisitosDeAcesso: {
        operador: OPERADORES_DE_VALIDACAO.OU,
        condicoes: [{ tipo: TIPO_CONDICAO.MODULO, modulo: [MODULOS.BASE] }]
      },
    }
  },
  {
    path: '/farol-do-dp-2',
    name: 'FarolDoDP2',
    component: FarolDoDP2,
    meta: {
      title: 'Farol do DP',
      requisitosDeAcesso: {
        operador: OPERADORES_DE_VALIDACAO.OU,
        condicoes: [{ tipo: TIPO_CONDICAO.MODULO, modulo: [MODULOS.BASE] }]
      },
    }
  },

  {
    path: '/farol-do-dp-2/meus-graficos',
    name: 'FarolDoDP2GraficosSalvos',
    component: FarolDoDP2,
    meta: {
      title: 'Farol do DP',
      requisitosDeAcesso: {
        operador: OPERADORES_DE_VALIDACAO.OU,
        condicoes: [{ tipo: TIPO_CONDICAO.MODULO, modulo: [MODULOS.BASE] }]
      },
    }
  },

  {
    path: '/farol-do-dp-2/turnover',
    name: 'FarolDoDP2Turnover',
    component: FarolDoDP2,
    meta: {
      title: 'Farol do DP',
      requisitosDeAcesso: {
        operador: OPERADORES_DE_VALIDACAO.OU,
        condicoes: [{ tipo: TIPO_CONDICAO.MODULO, modulo: [MODULOS.BASE] }]
      },
    }
  },

  {
    path: '/farol-do-dp-2/solicitacao-he',
    name: 'FarolDoDP2SolicitacaoHe',
    component: FarolDoDP2,
    meta: {
      title: 'Farol do DP',
      requisitosDeAcesso: {
        operador: OPERADORES_DE_VALIDACAO.OU,
        condicoes: [{ tipo: TIPO_CONDICAO.MODULO, modulo: [MODULOS.BASE] }]
      },
    }
  },

  {
    path: '/farol-do-dp-2/banco-de-horas',
    name: 'FarolDoDP2BancoDeHoras',
    component: FarolDoDP2,
    meta: {
      title: 'Farol do DP',
      requisitosDeAcesso: {
        operador: OPERADORES_DE_VALIDACAO.OU,
        condicoes: [{ tipo: TIPO_CONDICAO.MODULO, modulo: [MODULOS.BASE] }]
      },
    }
  },

  {
    path: '/farol-do-dp-2/dispensas',
    name: 'FarolDoDP2Dispensas',
    component: FarolDoDP2,
    meta: {
      title: 'Farol do DP',
      requisitosDeAcesso: {
        operador: OPERADORES_DE_VALIDACAO.OU,
        condicoes: [{ tipo: TIPO_CONDICAO.MODULO, modulo: [MODULOS.BASE] }]
      },
    }
  },

  {
    path: '/faturas',
    name: 'Faturas',
    component: Faturas,
    meta: {
      title: 'Faturas Disponíveis',
      requisitosDeAcesso: {
        operador: OPERADORES_DE_VALIDACAO.OU,
        condicoes: [{ tipo: TIPO_CONDICAO.MODULO, modulo: [MODULOS.BASE] }]
      },
    }
  },
]

export default [
  ...ROTAS_BASE,

  {
    path: '/reason',
    name: 'reason',
    component: simpleChildrenWrapper,
    children: [
      {
        path: 'list',
        name: 'reason.list',
        component: ReasonList,
        meta: {
          title: i18n.t('router.routes.motivos'),
          requisitosDeAcesso: {
            operador: OPERADORES_DE_VALIDACAO.OU,
            condicoes: [{ tipo: TIPO_CONDICAO.MODULO, modulo: [MODULOS.CALCULOS_E_TRATAMENTOS, MODULOS.LEGADO] }]
          }
        }
      },
      {
        path: 'new', name: 'reason.new', component: ReasonDetails,
        meta: {
          title: i18n.t('router.routes.novoMotivo'),
          requisitosDeAcesso: {
            operador: OPERADORES_DE_VALIDACAO.OU,
            condicoes: [{ tipo: TIPO_CONDICAO.MODULO, modulo: [MODULOS.CALCULOS_E_TRATAMENTOS, MODULOS.LEGADO] }]
          }
        }
      },
      {
        path: UUIDPathUrl, name: 'reason.edit', component: ReasonDetails, props: true,
        meta: {
          title: i18n.t('router.routes.editarMotivo'),
          parametroDeIdentidade: 'id',
          requisitosDeAcesso: {
            operador: OPERADORES_DE_VALIDACAO.OU,
            condicoes: [{ tipo: TIPO_CONDICAO.MODULO, modulo: [MODULOS.CALCULOS_E_TRATAMENTOS, MODULOS.LEGADO] }]
          }
        }
      }
    ],
    meta: {
      requisitosDeAcesso: {
        operador: OPERADORES_DE_VALIDACAO.OU,
        condicoes: [{ tipo: TIPO_CONDICAO.MODULO, modulo: [MODULOS.CALCULOS_E_TRATAMENTOS, MODULOS.LEGADO] }]
      }
    }
  },

  {
    path: '/timesheet/employee/:id([0-9a-f]{15,})/:dia(\\d{4}-\\d{2}-\\d{2})?',
    name: 'timesheet.employee.current',
    component: () => import('src/components/Sheets/Timesheet/RedirecionarParaFolhaAtual.vue'),
    props: true,
    meta: {
      title: i18n.t('router.routes.folhas'),
      dontNeedAuth: false,
      requisitosDeAcesso: {
        operador: OPERADORES_DE_VALIDACAO.OU,
        condicoes: [{ tipo: TIPO_CONDICAO.MODULO, modulo: [MODULOS.REGISTRO_DE_PONTO, MODULOS.CALCULOS_E_TRATAMENTOS, MODULOS.LEGADO] }]
      },
    },
  },

  {
    path: '/timesheet/:type/:startDate/:endDate(\\d{4}-\\d{2}-\\d{2}|null)?/:id([0-9abcdef]{15,})?',
    name: 'timesheet',
    component: Timesheet,
    props: true,
    meta: {
      title: i18n.t('router.routes.folhas'),
      dontNeedAuth: false,
      requisitosDeAcesso: {
        operador: OPERADORES_DE_VALIDACAO.OU,
        condicoes: [{ tipo: TIPO_CONDICAO.MODULO, modulo: [MODULOS.REGISTRO_DE_PONTO, MODULOS.CALCULOS_E_TRATAMENTOS, MODULOS.LEGADO] }]
      },
    },
  },

  {
    path: '/painel-pontos',
    name: 'painelDePontos',
    component: PainelDePontos,
    meta: {
      title: i18n.t('router.routes.painelDePontos'),
      dontNeedAuth: false,
      requisitosDeAcesso: {
        operador: OPERADORES_DE_VALIDACAO.OU,
        condicoes: [{ tipo: TIPO_CONDICAO.MODULO, modulo: [MODULOS.REGISTRO_DE_PONTO, MODULOS.LEGADO] }]
      },
    }
  },

  {
    path: '/deviceManage/list',
    name: 'devices-management',
    component: DevicesList,
    meta: {
      title: i18n.t('router.routes.dispositivos'),
      requisitosDeAcesso: {
        operador: OPERADORES_DE_VALIDACAO.OU,
        condicoes: [{ tipo: TIPO_CONDICAO.MODULO, modulo: [MODULOS.REGISTRO_DE_PONTO, MODULOS.LEGADO] }]
      }
    }
  },

  {
    path: '/controle-de-estacoes',
    name: 'controle-de-estacoes',
    component: ControleDeEstacoes,
    meta: {
      title: i18n.t('router.routes.controleDeEstacoes'),
      requerPermissaoControleDeEstacoes: true,
      requisitosDeAcesso: {
        operador: OPERADORES_DE_VALIDACAO.E,
        condicoes: [{ tipo: TIPO_CONDICAO.FUNCIONALIDADE, modulo: [FUNCIONALIDADES.CONTROLE_DE_ESTACOES] }]
      }
    }
  },

  {
    path: '/controle-de-estacoes/stations/:deviceId',
    name: 'controle-de-estacoes.station-detail',
    component: ControleDeEstacoes,
    props: true,
    meta: {
      title: i18n.t('router.routes.controleDeEstacoes'),
      requerPermissaoControleDeEstacoes: true,
      requisitosDeAcesso: {
        operador: OPERADORES_DE_VALIDACAO.E,
        condicoes: [{ tipo: TIPO_CONDICAO.FUNCIONALIDADE, modulo: [FUNCIONALIDADES.CONTROLE_DE_ESTACOES] }]
      }
    }
  },

  {
    path: '/coletores',
    name: 'coletores',
    component: simpleChildrenWrapper,
    children: [
      {
        path: 'listar',
        name: 'coletores.listar',
        component: ListagemDeColetores,
        meta: {
          title: i18n.t('router.routes.coletores'),
          requisitosDeAcesso: {
            operador: OPERADORES_DE_VALIDACAO.OU,
            condicoes: [{ tipo: TIPO_CONDICAO.MODULO, modulo: [MODULOS.REGISTRO_DE_PONTO, MODULOS.REDUCAO_DE_RISCOS, MODULOS.LEGADO] }]
          }
        }
      },
      {
        path: 'perfil',
        name: 'perfil',
        component: simpleChildrenWrapper,
        children: [
          {
            path: 'criar',
            name: 'perfil.criar',
            component: CriacaoEdicaoDePerfil,
            meta: {
              title: 'Novo perfil',
              requisitosDeAcesso: {
                operador: OPERADORES_DE_VALIDACAO.OU,
                condicoes: [{ tipo: TIPO_CONDICAO.MODULO, modulo: [MODULOS.REGISTRO_DE_PONTO, MODULOS.REDUCAO_DE_RISCOS, MODULOS.LEGADO] }]
              }
            }
          },
          {
            path: ':id([a-fA-F0-9]{8}-[a-fA-F0-9]{4}-[a-fA-F0-9]{4}-[a-fA-F0-9]{4}-[a-fA-F0-9]{12})',
            name: 'perfil.editar',
            props: true,
            component: CriacaoEdicaoDePerfil,
            meta: {
              title: 'Editar perfil',
              requisitosDeAcesso: {
                operador: OPERADORES_DE_VALIDACAO.OU,
                condicoes: [{ tipo: TIPO_CONDICAO.MODULO, modulo: [MODULOS.REGISTRO_DE_PONTO, MODULOS.REDUCAO_DE_RISCOS, MODULOS.LEGADO] }]
              }
            }
          }
        ]
      }
    ],
    meta: {
      requisitosDeAcesso: {
        operador: OPERADORES_DE_VALIDACAO.OU,
        condicoes: [{ tipo: TIPO_CONDICAO.MODULO, modulo: [MODULOS.REGISTRO_DE_PONTO, MODULOS.REDUCAO_DE_RISCOS, MODULOS.LEGADO] }]
      }
    }
  },
  {
    path: '/biometria/acesso-negado',
    name: 'biometria-acesso-negado',
    component: PaginaAcessoPeloComputador,
    meta: {
      title: i18n.t('router.routes.biometria'),
      requisitosDeAcesso: {
        operador: OPERADORES_DE_VALIDACAO.OU,
        condicoes: [{ tipo: TIPO_CONDICAO.MODULO, modulo: [MODULOS.REDUCAO_DE_RISCOS, MODULOS.LEGADO] }]
      }
    }
  },
  {
    path: '/biometria/autenticar',
    name: 'biometria-autenticar',
    component: PaginaAutenticarBiometria,
    meta: {
      title: i18n.t('router.routes.biometria'),
      requisitosDeAcesso: {
        operador: OPERADORES_DE_VALIDACAO.OU,
        condicoes: [{ tipo: TIPO_CONDICAO.MODULO, modulo: [MODULOS.REDUCAO_DE_RISCOS, MODULOS.LEGADO] }]
      }
    }
  },
  {
    path: '/biometria/confirmar-identidade',
    name: 'biometria-confirmar-identidade',
    component: PaginaConfirmarIdentidade,
    meta: {
      title: i18n.t('router.routes.biometria'),
      requisitosDeAcesso: {
        operador: OPERADORES_DE_VALIDACAO.OU,
        condicoes: [{ tipo: TIPO_CONDICAO.MODULO, modulo: [MODULOS.REDUCAO_DE_RISCOS, MODULOS.LEGADO] }]
      }
    }
  },

  {
    path: '/biometria/camera',
    name: 'biometria-camera',
    component: PaginaCameraBiometria,
    meta: {
      title: i18n.t('router.routes.biometria'),
      requisitosDeAcesso: {
        operador: OPERADORES_DE_VALIDACAO.OU,
        condicoes: [{ tipo: TIPO_CONDICAO.MODULO, modulo: [MODULOS.REDUCAO_DE_RISCOS, MODULOS.LEGADO] }]
      }
    }
  },

  {
    path: '/face-biometric',
    name: 'face-biometric',
    component: FaceBiometric,
    meta: {
      title: i18n.t('router.routes.biometria'),
      requisitosDeAcesso: {
        operador: OPERADORES_DE_VALIDACAO.OU,
        condicoes: [{ tipo: TIPO_CONDICAO.MODULO, modulo: [MODULOS.REDUCAO_DE_RISCOS, MODULOS.LEGADO] }]
      }
    }
  },

  {
    path: '/gerenciamento-de-arquivos',
    name: 'fileManagement',
    component: simpleChildrenWrapper,
    children: [
      {
        path: 'list',
        name: 'fileManagement.list',
        component: FileManagementList,
        meta: {
          title: i18n.t('router.routes.fileManagement.gerenciamento'),
          requisitosDeAcesso: {
            operador: OPERADORES_DE_VALIDACAO.OU,
            condicoes: [{ tipo: TIPO_CONDICAO.MODULO, modulo: [MODULOS.REDUCAO_DE_RISCOS, MODULOS.LEGADO] }]
          }
        }
      },
      {
        path: 'aprovacao/:id',
        name: 'fileManagement.edit',
        component: FileManagementApproval, props: true,
        meta: {
          title: i18n.t('router.routes.fileManagement.aprovacao'),
          requisitosDeAcesso: {
            operador: OPERADORES_DE_VALIDACAO.OU,
            condicoes: [{ tipo: TIPO_CONDICAO.MODULO, modulo: [MODULOS.REDUCAO_DE_RISCOS, MODULOS.LEGADO] }]
          }
        }
      }
    ],
    meta: {
      requisitosDeAcesso: {
        operador: OPERADORES_DE_VALIDACAO.OU,
        condicoes: [{ tipo: TIPO_CONDICAO.MODULO, modulo: [MODULOS.REDUCAO_DE_RISCOS, MODULOS.LEGADO] }]
      }
    }
  },

  {
    path: '/verify-timesheet',
    name: 'verifyTimesheet',
    component: VerifyTimesheet,
    meta: {
      title: i18n.t('router.routes.verificarFolha'),
      requisitosDeAcesso: {
        operador: OPERADORES_DE_VALIDACAO.OU,
        condicoes: [{ tipo: TIPO_CONDICAO.MODULO, modulo: [MODULOS.CALCULOS_E_TRATAMENTOS, MODULOS.LEGADO] }]
      }
    }
  },

  {
    path: '/fechar-folha-em-conjunto',
    name: 'locker-management',
    component: LockerManagement,
    props: true,
    meta: {
      title: i18n.t('router.routes.travamentoDeFolha'),
      requisitosDeAcesso: {
        operador: OPERADORES_DE_VALIDACAO.OU,
        condicoes: [{ tipo: TIPO_CONDICAO.MODULO, modulo: [MODULOS.CALCULOS_E_TRATAMENTOS, MODULOS.LEGADO] }]
      }
    }
  },

  {
    path: '/fast',
    name: 'mass-changes',
    component: MassChanges,
    meta: {
      title: i18n.t('router.routes.alteracoesEmMassa'),
      requisitosDeAcesso: {
        operador: OPERADORES_DE_VALIDACAO.OU,
        condicoes: [{ tipo: TIPO_CONDICAO.MODULO, modulo: [MODULOS.CALCULOS_E_TRATAMENTOS, MODULOS.LEGADO] }]
      }
    }
  },

  {
    path: '/gerenciamento-banco/empregado/:empregadoId([0-9a-f]{24})',
    name: 'whb-management.employee',
    component: WhbManagement,
    props: true,
    meta: {
      title: i18n.t('router.routes.gestaoBH'),
      requisitosDeAcesso: {
        operador: OPERADORES_DE_VALIDACAO.OU,
        condicoes: [{ tipo: TIPO_CONDICAO.MODULO, modulo: [MODULOS.CALCULOS_E_TRATAMENTOS, MODULOS.LEGADO] }]
      }
    }
  },
  {
    path: '/gerenciamento-banco',
    name: 'whb-management',
    component: WhbManagement,
    meta: {
      title: i18n.t('router.routes.gestaoBH'),
      requisitosDeAcesso: {
        operador: OPERADORES_DE_VALIDACAO.OU,
        condicoes: [{ tipo: TIPO_CONDICAO.MODULO, modulo: [MODULOS.CALCULOS_E_TRATAMENTOS, MODULOS.LEGADO] }]
      }
    }
  },

  {
    path: '/timeoff',
    name: 'timeoff',
    component: simpleChildrenWrapper,
    children: [
      {
        path: 'list',
        name: 'timeoff.list',
        component: ListagemDasRegrasDeBancoDeHoras,
        meta: {
          title: i18n.t('router.routes.timeoff.regraBH'),
          requisitosDeAcesso: {
            operador: OPERADORES_DE_VALIDACAO.OU,
            condicoes: [{ tipo: TIPO_CONDICAO.MODULO, modulo: [MODULOS.CALCULOS_E_TRATAMENTOS, MODULOS.LEGADO] }]
          }
        }
      },
      {
        path: 'new',
        name: 'timeoff.new',
        component: DetalhesDeRegraDeBancoDeHoras,
        meta: {
          title: i18n.t('router.routes.timeoff.novaRegra'),
          requisitosDeAcesso: {
            operador: OPERADORES_DE_VALIDACAO.OU,
            condicoes: [{ tipo: TIPO_CONDICAO.MODULO, modulo: [MODULOS.CALCULOS_E_TRATAMENTOS, MODULOS.LEGADO] }]
          }
        }
      },
      {
        path: UUIDOrObjectIdPathUrl,
        name: 'timeoff.edit',
        component: DetalhesDeRegraDeBancoDeHoras,
        props: true,
        meta: {
          title: i18n.t('router.routes.approvalsRules.editarRegra'),
          requisitosDeAcesso: {
            operador: OPERADORES_DE_VALIDACAO.OU,
            condicoes: [{ tipo: TIPO_CONDICAO.MODULO, modulo: [MODULOS.CALCULOS_E_TRATAMENTOS, MODULOS.LEGADO] }]
          }
        }
      }
    ],
    meta: {
      requisitosDeAcesso: {
        operador: OPERADORES_DE_VALIDACAO.OU,
        condicoes: [{ tipo: TIPO_CONDICAO.MODULO, modulo: [MODULOS.CALCULOS_E_TRATAMENTOS, MODULOS.LEGADO] }]
      }
    }
  },

  {
    path: '/regras-de-travamento',
    name: 'lockerRules',
    component: simpleChildrenWrapper,
    children: [
      {
        path: 'list',
        name: 'lockerRules.list',
        component: LockerRulesList,
        meta: {
          title: i18n.t('router.routes.lockerRules.regraTravamento'),
          requisitosDeAcesso: {
            operador: OPERADORES_DE_VALIDACAO.OU,
            condicoes: [{ tipo: TIPO_CONDICAO.MODULO, modulo: [MODULOS.GESTAO_PARTICIPATIVA, MODULOS.LEGADO] }]
          }
        }
      },
      {
        path: 'criacao',
        name: 'lockerRules.criacao',
        component: LockerRulesDetails,
        meta: {
          title: i18n.t('router.routes.lockerRules.novaRegra'),
          requisitosDeAcesso: {
            operador: OPERADORES_DE_VALIDACAO.OU,
            condicoes: [{ tipo: TIPO_CONDICAO.MODULO, modulo: [MODULOS.CALCULOS_E_TRATAMENTOS, MODULOS.LEGADO] }]
          }
        }
      },
      {
        path: UUIDPathUrl,
        name: 'lockerRules.edit',
        component: LockerRulesDetails,
        props: true,
        meta: {
          title: i18n.t('router.routes.approvalsRules.editarRegra'),
          requisitosDeAcesso: {
            operador: OPERADORES_DE_VALIDACAO.OU,
            condicoes: [{ tipo: TIPO_CONDICAO.MODULO, modulo: [MODULOS.CALCULOS_E_TRATAMENTOS, MODULOS.LEGADO] }]
          }
        }
      }
    ],
    meta: {
      requisitosDeAcesso: {
        operador: OPERADORES_DE_VALIDACAO.OU,
        condicoes: [{ tipo: TIPO_CONDICAO.MODULO, modulo: [MODULOS.CALCULOS_E_TRATAMENTOS, MODULOS.LEGADO] }]
      }
    }
  },

  {
    path: '/customizacoes-de-calculo',
    name: 'customizacoesDeCalculo',
    component: simpleChildrenWrapper,
    children: [
      {
        path: 'listar',
        name: 'customizacoesDeCalculo.listar',
        component: ListagemDaCustomizacaoDeCalculo,
        meta: {
          title: i18n.t('router.routes.regrasDeCalculo.regras'),
          requisitosDeAcesso: {
            operador: OPERADORES_DE_VALIDACAO.OU,
            condicoes: [{ tipo: TIPO_CONDICAO.MODULO, modulo: [MODULOS.CALCULOS_E_TRATAMENTOS, MODULOS.LEGADO] }]
          }
        }
      },
      {
        path: 'regra-de-calculo',
        name: 'regraDeCalculo',
        component: simpleChildrenWrapper,
        children: [
          {
            path: 'criar',
            name: 'regrasDeCalculo.criar',
            component: CriacaoEdicaoDaRegraDeCalculo,
            meta: {
              title: i18n.t('router.routes.regrasDeCalculo.novaRegra'),
              requisitosDeAcesso: {
                operador: OPERADORES_DE_VALIDACAO.OU,
                condicoes: [{ tipo: TIPO_CONDICAO.MODULO, modulo: [MODULOS.CALCULOS_E_TRATAMENTOS, MODULOS.LEGADO] }]
              }
            }
          },
          {
            path: ':id([0-9abcdef]{15,})',
            name: 'regrasDeCalculo.editar',
            component: CriacaoEdicaoDaRegraDeCalculo,
            props: true,
            meta: {
              title: i18n.t('router.routes.regrasDeCalculo.editarRegra'),
              requisitosDeAcesso: {
                operador: OPERADORES_DE_VALIDACAO.OU,
                condicoes: [{ tipo: TIPO_CONDICAO.MODULO, modulo: [MODULOS.CALCULOS_E_TRATAMENTOS, MODULOS.LEGADO] }]
              }
            }
          }
        ]
      },
      {
        path: 'grupo-de-rubricas',
        name: 'grupoDeRubricas',
        component: simpleChildrenWrapper,
        children: [
          {
            path: 'criar',
            name: 'grupoDeRubricas.criar',
            component: CriacaoEdicaoGrupoDeRubricas,
            meta: {
              title: 'Novo grupo',
              requisitosDeAcesso: {
                operador: OPERADORES_DE_VALIDACAO.OU,
                condicoes: [{ tipo: TIPO_CONDICAO.MODULO, modulo: [MODULOS.CALCULOS_E_TRATAMENTOS, MODULOS.LEGADO] }]
              }
            }
          },
          {
            path: ':id([a-fA-F0-9]{8}-[a-fA-F0-9]{4}-[a-fA-F0-9]{4}-[a-fA-F0-9]{4}-[a-fA-F0-9]{12})',
            name: 'grupoDeRubricas.editar',
            component: CriacaoEdicaoGrupoDeRubricas,
            props: true,
            meta: {
              title: 'Editar grupo',
              requisitosDeAcesso: {
                operador: OPERADORES_DE_VALIDACAO.OU,
                condicoes: [{ tipo: TIPO_CONDICAO.MODULO, modulo: [MODULOS.CALCULOS_E_TRATAMENTOS, MODULOS.LEGADO] }]
              }
            }
          }
        ]
      }
    ],
    meta: {
      requisitosDeAcesso: {
        operador: OPERADORES_DE_VALIDACAO.OU,
        condicoes: [{ tipo: TIPO_CONDICAO.MODULO, modulo: [MODULOS.CALCULOS_E_TRATAMENTOS, MODULOS.LEGADO] }]
      }
    }
  },

  {
    path: '/parametrizador',
    name: 'parametrizador',
    component: simpleChildrenWrapper,
    children: [
      {
        path: 'listar',
        name: 'parametrizador.listar',
        component: ListagemDeVerbas,
        meta: {
          title: 'Listagem de Verbas',
          requisitosDeAcesso: {
            operador: OPERADORES_DE_VALIDACAO.OU,
            condicoes: [{ tipo: TIPO_CONDICAO.MODULO, modulo: [MODULOS.CALCULOS_E_TRATAMENTOS, MODULOS.LEGADO] }]
          }
        }
      }
    ],
    meta: {
      requisitosDeAcesso: {
        operador: OPERADORES_DE_VALIDACAO.OU,
        condicoes: [{ tipo: TIPO_CONDICAO.MODULO, modulo: [MODULOS.CALCULOS_E_TRATAMENTOS, MODULOS.LEGADO] }]
      }
    }
  },

  {
    path: '/layoutE02',
    component: simpleChildrenWrapper,
    children: [
      {
        path: '',
        name: 'layoutE02',
        component: ListaLayoutsE02,
        meta: {
          title: 'Layouts E02',
          requisitosDeAcesso: {
            operador: OPERADORES_DE_VALIDACAO.OU,
            condicoes: [{ tipo: TIPO_CONDICAO.MODULO, modulo: [MODULOS.CALCULOS_E_TRATAMENTOS, MODULOS.LEGADO] }]
          }
        }
      },
      {
        path: 'exportadorE02',
        name: 'exportadorE02',
        component: Exportador,
        meta: {
          title: 'Exportador E02',
          requisitosDeAcesso: {
            operador: OPERADORES_DE_VALIDACAO.OU,
            condicoes: [{ tipo: TIPO_CONDICAO.MODULO, modulo: [MODULOS.CALCULOS_E_TRATAMENTOS, MODULOS.LEGADO] }]
          }
        }
      }
    ],
    meta: {
      requisitosDeAcesso: {
        operador: OPERADORES_DE_VALIDACAO.OU,
        condicoes: [{ tipo: TIPO_CONDICAO.MODULO, modulo: [MODULOS.CALCULOS_E_TRATAMENTOS, MODULOS.LEGADO] }]
      }
    }
  },

  {
    path: '/approvals',
    name: 'approvals',
    component: GestaoDeSolicitacoes,
    meta: {
      title: i18n.t('router.routes.gestaoSolicitacoes'),
      requisitosDeAcesso: {
        operador: OPERADORES_DE_VALIDACAO.OU,
        condicoes: [{ tipo: TIPO_CONDICAO.MODULO, modulo: [MODULOS.GESTAO_PARTICIPATIVA, MODULOS.CONTROLE_CUSTOS, MODULOS.GESTAO_DE_FERIAS_E_AUSENCIAS, MODULOS.LEGADO] }]
      }
    }
  },
  {
    path: '/chat-politicas',
    name: 'chat-politicas',
    component: ChatPoliticas,
    meta: {
      title: i18n.t('router.routes.chatPoliticas'),
      requisitosDeAcesso: {
        operador: OPERADORES_DE_VALIDACAO.OU,
        condicoes: [{ tipo: TIPO_CONDICAO.FUNCIONALIDADE, modulo: [FUNCIONALIDADES.FUNCIONALIDADE_IA_POLITICA_FECHAMENTO] }]
      }
    }
  },

  {
    path: '/approvals-rules',
    name: 'approvalsRules',
    component: simpleChildrenWrapper,
    children: [
      {
        path: 'list',
        name: 'approvalRules.list',
        component: ApprovalsRulesList,
        meta: {
          title: i18n.t('router.routes.approvalsRules.regras'),
          requisitosDeAcesso: {
            operador: OPERADORES_DE_VALIDACAO.OU,
            condicoes: [{ tipo: TIPO_CONDICAO.MODULO, modulo: [MODULOS.GESTAO_PARTICIPATIVA, MODULOS.CONTROLE_CUSTOS, MODULOS.GESTAO_DE_FERIAS_E_AUSENCIAS, MODULOS.LEGADO] }]
          }
        }
      },
      {
        path: 'new',
        name: 'approvalRules.new',
        component: ApprovalsRulesDetails,
        meta: {
          title: i18n.t('router.routes.approvalsRules.novaRegra'),
          requisitosDeAcesso: {
            operador: OPERADORES_DE_VALIDACAO.OU,
            condicoes: [{ tipo: TIPO_CONDICAO.MODULO, modulo: [MODULOS.GESTAO_PARTICIPATIVA, MODULOS.CONTROLE_CUSTOS, MODULOS.GESTAO_DE_FERIAS_E_AUSENCIAS, MODULOS.LEGADO] }]
          }
        }
      },
      {
        path: UUIDOrObjectIdPathUrl,
        name: 'approvalRules.edit',
        component: ApprovalsRulesDetails,
        props: true,
        meta: {
          title: i18n.t('router.routes.approvalsRules.editarRegra'),
          requisitosDeAcesso: {
            operador: OPERADORES_DE_VALIDACAO.OU,
            condicoes: [{ tipo: TIPO_CONDICAO.MODULO, modulo: [MODULOS.GESTAO_PARTICIPATIVA, MODULOS.CONTROLE_CUSTOS, MODULOS.GESTAO_DE_FERIAS_E_AUSENCIAS, MODULOS.LEGADO] }]
          }
        }
      }
    ],
    meta: {
      requisitosDeAcesso: {
        operador: OPERADORES_DE_VALIDACAO.OU,
        condicoes: [{ tipo: TIPO_CONDICAO.MODULO, modulo: [MODULOS.GESTAO_PARTICIPATIVA, MODULOS.CONTROLE_CUSTOS, MODULOS.GESTAO_DE_FERIAS_E_AUSENCIAS, MODULOS.LEGADO] }]
      },
    }
  },

  {
    path: '/painel-solicitacoes-horas-extras',
    name: 'painelDeSolicitacoesDeHorasExtra',
    component: PainelDeSolicitacoesDeHorasExtras,
    meta: {
      title: i18n.t('router.routes.painelDeSolicitacoesDeHorasExtras'),
      requisitosDeAcesso: {
        operador: OPERADORES_DE_VALIDACAO.OU,
        condicoes: [{ tipo: TIPO_CONDICAO.FUNCIONALIDADE, modulo: [FUNCIONALIDADES.GESTAO_HORAS_EXTRAS_LIMITE_ACOMPANHAMENTO]}]
      }
    },
  },

  {
    path: '/approvals/lancar-solicitacoes',
    name: 'lancarSolicitacoes',
    component: LancarSolicitacoes,
    meta: {
      title: i18n.t('router.routes.lancarSolicitacoes'),
      requisitosDeAcesso: {
        operador: OPERADORES_DE_VALIDACAO.OU,
        condicoes: [{ tipo: TIPO_CONDICAO.MODULO, modulo: [MODULOS.GESTAO_PARTICIPATIVA, MODULOS.CONTROLE_CUSTOS, MODULOS.GESTAO_DE_FERIAS_E_AUSENCIAS, MODULOS.LEGADO] }]
      }
    },
  },

  {
    path: '/approvals/minhas-solicitacoes',
    name: 'minhasSolicitacoes',
    component: MinhasSolicitacoes,
    meta: {
      title: i18n.t('router.routes.minhasSolicitacoes'),
      requisitosDeAcesso: {
        operador: OPERADORES_DE_VALIDACAO.OU,
        condicoes: [{ tipo: TIPO_CONDICAO.MODULO, modulo: [MODULOS.GESTAO_PARTICIPATIVA, MODULOS.CONTROLE_CUSTOS, MODULOS.GESTAO_DE_FERIAS_E_AUSENCIAS, MODULOS.LEGADO] }]
      }
    },
  },

  {
    path: '/extra-time-dashboard',
    name: 'extraTimeDashboard',
    component: ExtraTimeDash,
    meta: {
      title: i18n.t('router.routes.painelAcompanhamento'),
      dontNeedAuth: false,
      requisitosDeAcesso: {
        operador: OPERADORES_DE_VALIDACAO.OU,
        condicoes: [{ tipo: TIPO_CONDICAO.MODULO, modulo: [MODULOS.CALCULOS_E_TRATAMENTOS, MODULOS.LEGADO] }]
      }
    }
  },

  {
    path: '/work-schedule',
    name: 'workSchedule',
    component: WorkSchedule,
    props: true,
    meta: {
      title: i18n.t('router.routes.escalasDeTrabalho'),
      requisitosDeAcesso: {
        operador: OPERADORES_DE_VALIDACAO.OU,
        condicoes: [{ tipo: TIPO_CONDICAO.MODULO, modulo: [MODULOS.CONTROLE_CUSTOS, MODULOS.LEGADO] }]
      }
    }
  },

  {
    path: '/acompanhamento-tempo-real',
    name: 'acompanhamentoTempoReal',
    component: AcompanhamentoTempoReal,
    meta: {
      title: i18n.t('router.routes.acompanhamentoTempoReal'),
      requisitosDeAcesso: {
        operador: OPERADORES_DE_VALIDACAO.OU,
        condicoes: [{ tipo: TIPO_CONDICAO.FUNCIONALIDADE, modulo: [FUNCIONALIDADES.ACOMPANHAMENTO_TEMPO_REAL] }]
      },
    }
  },

  {
    path: '/regras-de-notificacao',
    component: RegrasDeNotificacao,
    children: [
      {
        path: '',
        name: 'regrasDeNotificacao.listagem',
        component: RegrasDeNotificacaoListagem,
        meta: {
          title: i18n.t('router.routes.regrasDeNotificacao.regra'),
          requisitosDeAcesso: {
            operador: OPERADORES_DE_VALIDACAO.OU,
            condicoes: [{ tipo: TIPO_CONDICAO.MODULO, modulo: [MODULOS.CONTROLE_CUSTOS, MODULOS.REGISTRO_DE_PONTO, MODULOS.CALCULOS_E_TRATAMENTOS, MODULOS.LEGADO] }]
          }
        }
      },
      {
        path: 'new',
        name: 'regrasDeNotificacao.criacao',
        component: CriarEditarRegraDeNotificacao,
        meta: {
          title: i18n.t('router.routes.regrasDeNotificacao.novaRegra'),
          requisitosDeAcesso: {
            operador: OPERADORES_DE_VALIDACAO.OU,
            condicoes: [{ tipo: TIPO_CONDICAO.MODULO, modulo: [MODULOS.CONTROLE_CUSTOS, MODULOS.REGISTRO_DE_PONTO, MODULOS.CALCULOS_E_TRATAMENTOS, MODULOS.LEGADO] }]
          }
        }
      },
      {
        path: ':id([a-fA-F0-9]{8}-[a-fA-F0-9]{4}-[a-fA-F0-9]{4}-[a-fA-F0-9]{4}-[a-fA-F0-9]{12})',
        name: 'regrasDeNotificacao.edicao',
        component: CriarEditarRegraDeNotificacao, props: true,
        meta: {
          title: i18n.t('router.routes.regrasDeNotificacao.editarRegra'),
          requisitosDeAcesso: {
            operador: OPERADORES_DE_VALIDACAO.OU,
            condicoes: [{ tipo: TIPO_CONDICAO.MODULO, modulo: [MODULOS.CONTROLE_CUSTOS, MODULOS.REGISTRO_DE_PONTO, MODULOS.CALCULOS_E_TRATAMENTOS, MODULOS.LEGADO] }]
          }
        }
      }
    ],
    meta: {
      requisitosDeAcesso: {
        operador: OPERADORES_DE_VALIDACAO.OU,
        condicoes: [{ tipo: TIPO_CONDICAO.MODULO, modulo: [MODULOS.CONTROLE_CUSTOS, MODULOS.REGISTRO_DE_PONTO, MODULOS.CALCULOS_E_TRATAMENTOS, MODULOS.LEGADO] }]
      }
    }
  },

  {
    path: '/gerenciamento-de-ferias/empregado/:empregadoId([0-9a-f]{24})',
    name: 'gerenciamentoDeFeriasDoEmpregado',
    component: GerenciamentoDeFerias,
    props: true,
    meta: {
      title: i18n.t('router.routes.gerenciamentoFerias'),
      requisitosDeAcesso: {
        operador: OPERADORES_DE_VALIDACAO.OU,
        condicoes: [{ tipo: TIPO_CONDICAO.FUNCIONALIDADE, modulo: [FUNCIONALIDADES.ACOMPANHAMENTO_FERIAS] }]
      }
    }
  },
  {
    path: '/gerenciamento-de-ferias',
    name: 'gerenciamentoDeFerias',
    component: GerenciamentoDeFerias,
    meta: {
      title: i18n.t('router.routes.gerenciamentoFerias'),
      requisitosDeAcesso: {
        operador: OPERADORES_DE_VALIDACAO.OU,
        condicoes: [{ tipo: TIPO_CONDICAO.FUNCIONALIDADE, modulo: [FUNCIONALIDADES.ACOMPANHAMENTO_FERIAS] }]
      }
    }
  },
  {
    path: '/regras-de-ferias',
    name: 'regrasDeFerias',
    component: RegrasDeFerias,
    meta: {
      title: i18n.t('router.routes.regrasDeFerias'),
      requisitosDeAcesso: {
        operador: OPERADORES_DE_VALIDACAO.OU,
        condicoes: [{ tipo: TIPO_CONDICAO.FUNCIONALIDADE, modulo: [FUNCIONALIDADES.ACOMPANHAMENTO_FERIAS] }]
      }
    }
  },
  {
    path: '/regras-de-ferias/criar',
    name: 'criarRegraDeFerias',
    component: CriarEditarRegraDeFerias,
    meta: {
      title: i18n.t('router.routes.criarRegraDeFerias'),
      requisitosDeAcesso: {
        operador: OPERADORES_DE_VALIDACAO.OU,
        condicoes: [{ tipo: TIPO_CONDICAO.FUNCIONALIDADE, modulo: [FUNCIONALIDADES.ACOMPANHAMENTO_FERIAS] }]
      }
    }
  },
  {
    path: '/regras-de-ferias/editar/:idDaRegra',
    name: 'editarRegraDeFerias',
    component: CriarEditarRegraDeFerias,
    meta: {
      title: i18n.t('router.routes.editarRegraDeFerias'),
      requisitosDeAcesso: {
        operador: OPERADORES_DE_VALIDACAO.OU,
        condicoes: [{ tipo: TIPO_CONDICAO.FUNCIONALIDADE, modulo: [FUNCIONALIDADES.ACOMPANHAMENTO_FERIAS] }]
      }
    }
  },
  {
    path: '/calendario-timesheet',
    name: 'CalendarioAloque',
    component: CalendarioAloque,
    meta: {
      title: i18n.t('calendarioAloque.titulo'),
      requisitosDeAcesso: {
        operador: OPERADORES_DE_VALIDACAO.OU,
        condicoes: [{ tipo: TIPO_CONDICAO.FUNCIONALIDADE, modulo: [FUNCIONALIDADES.ACESSO_TIMESHEET] }]
      }
    }
  },
  {
    path: '/calendario-de-ferias',
    name: 'CalendarioDeFerias',
    component: CalendarioDeFerias,
    meta: {
      title: i18n.t('router.routes.calendarioDeFerias'),
      requisitosDeAcesso: {
        operador: OPERADORES_DE_VALIDACAO.OU,
        condicoes: [{ tipo: TIPO_CONDICAO.FUNCIONALIDADE, modulo: [FUNCIONALIDADES.ACOMPANHAMENTO_FERIAS] }]
      }
    }
  },

  { path: '/:pathMatch(.*)*', redirect: { name: 'home' } },
]
